import { IconButton } from '@mui/material'
import { MoonIcon, SunIcon } from 'lucide-react'
import React from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const ToggleTheme: React.FC = () => {
    const mode = useThemeStore(state => state.theme)
    const toggleTheme = useThemeStore(state => state.toggle)

    if (mode === 'dark') {
        document.documentElement.classList.remove('light')
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
        document.documentElement.classList.add('light')
    }

    return (
        <div className="flex items-center justify-center px-2">
            <IconButton onClick={toggleTheme} title="Alternar tema">
                {mode === 'dark' ? (
                    <SunIcon className="text-yellow-300" />
                ) : (
                    <MoonIcon className="text-gray-300" />
                )}
            </IconButton>
        </div>
    )
}

export const useThemeStore = create(
    persist<{ theme: 'dark' | 'light'; toggle: () => void }>(
        (set, get) => ({
            theme: 'light',
            toggle: () =>
                set({ theme: get().theme === 'dark' ? 'light' : 'dark' }),
        }),
        {
            name: 'theme',
        },
    ),
)

// const themeKey = 'pontoagil:theme'

// function getThemeMode(): 'light' | 'dark' {
//     return (localStorage.getItem(themeKey) as any) || 'light'
// }

// function toggleTheme(): 'light' | 'dark' {
//     const theme = getThemeMode()
//     const newTheme = theme === 'light' ? 'dark' : 'light'
//     localStorage.setItem(themeKey, newTheme)
//     return newTheme
// }

// export function useTheme() {
//     const [theme, setTheme] = React.useState(getThemeMode())

//     return {
//         theme,
//         toggleTheme: () => setTheme(toggleTheme()),
//     }
// }
